import {
  exportToCsv,
  duplicateSelectedRows,
  deleteSelectedRows,
  selectAllRows,
  clearData,
  PinnedRowTop,
  PinnedRowBottom,
  sizeToFit,
  autoSizeAll
} from './helpers'

// Actions share some of the i18n keys with the official agGrid i18n keys
// https://www.ag-grid.com/javascript-grid-localisation/localisation/locale.en.js
export const defaultActions = (
  {
    canExportCSV,
    canDuplicate,
    canDeleteRows,
    canClearAll,
    canPinRowBottom,
    canSelectAll,
    canPinRowTop,
    isSizeToFit,
    isAutoSize,
    isAutoSizeAll
  },
  { onRowAdd, onRowDelete },
  localeActionKeys
) =>
  [
    canExportCSV && {
      title: 'Export CSV',
      i18nKey: localeActionKeys.exportCSV,
      onClick: (gridApi) => {
        exportToCsv(gridApi)
      }
    },
    canDuplicate && {
      title: 'Duplicate Rows',
      i18nKey: localeActionKeys.duplicate,
      onClick: (gridApi) => {
        duplicateSelectedRows(gridApi, onRowAdd)
      }
    },
    canSelectAll && {
      title: 'Select All',
      i18nKey: localeActionKeys.selectAll,
      onClick: (gridApi) => {
        selectAllRows(gridApi)
      }
    },
    canDeleteRows && {
      title: 'Delete Rows',
      i18nKey: localeActionKeys.delete,
      isDelete: true,
      onClick: (gridApi) => {
        deleteSelectedRows(gridApi, onRowDelete)
      }
    },
    canClearAll && {
      title: 'Clear All',
      i18nKey: localeActionKeys.clearAll,
      onClick: (gridApi) => {
        clearData(gridApi)
      }
    },
    canPinRowTop && {
      title: 'Pin Row Top',
      i18nKey: localeActionKeys.pinRowTop,
      onClick: (gridApi) => {
        PinnedRowTop(gridApi)
      }
    },
    canPinRowBottom && {
      title: 'Pin Row Bottom',
      i18nKey: localeActionKeys.pinRowBottom,
      onClick: (gridApi) => {
        PinnedRowBottom(gridApi)
      }
    },
    isSizeToFit && {
      title: 'Size to Fit',
      i18nKey: localeActionKeys.sizeToFit,
      onClick: (gridApi) => {
        sizeToFit(gridApi)
      }
    },
    isAutoSizeAll && {
      title: 'Auto-Size All',
      i18nKey: localeActionKeys.autoSizeAll,
      onClick: (_, columnApi) => {
        autoSizeAll(false, columnApi)
      }
    },
    isAutoSize && {
      title: 'Auto-Size (Skip Header)',
      i18nKey: localeActionKeys.autoSizeSkipHeader,
      onClick: (_, columnApi) => {
        autoSizeAll(true, columnApi)
      }
    }
  ].filter(Boolean)

export default defaultActions
